<template>
  <div>
    <reset-slider
      :value="brightness"
      :color="colorHex"
      @input="$emit('updateBrightness', $event)"
      :min="-0.5"
      :max="0.5"
      :step="0.05"
      :defaultValue="defaultBrightness"
      name="Brightness"
      :limit="true"/>
    <reset-slider
      :value="contrast"
      :color="colorHex"
      @input="$emit('updateContrast', $event)"
      :min="0.5"
      :max="1.5"
      :step="0.05"
      :defaultValue="defaultContrast"
      name="Contrast"
      :limit="true"/>
    <reset-slider
      :value="gamma"
      :color="colorHex"
      @input="$emit('updateGamma', $event)"
      :min="0.1"
      :max="1.9"
      :step="0.05"
      :defaultValue="defaultGamma"
      name="Gamma"
      :limit="true"/>
  </div>
</template>

<script>
import resetSlider from "../../controls/ResetSlider";
import {
  DEFAULT_BRIGHTNESS,
  DEFAULT_CONTRAST,
  DEFAULT_GAMMA
} from "../../../canvas/canvasUtils";

export default {
  name: "annotationSliderCollection",
  components: { resetSlider },
  props: {
    context: Object,
    size: { type: String, default: "small" },
    gamma: Number,
    contrast: Number,
    brightness: Number
  },  
  data() {
    return {
      defaultBrightness: DEFAULT_BRIGHTNESS,
      defaultContrast: DEFAULT_CONTRAST,
      defaultGamma: DEFAULT_GAMMA
    };
  },
};
</script>
